<template>
  <div :class="$style.container">
    <BarChart :height="280" :chartData="chartData" :options="options"/>
  </div>
</template>

<style lang="scss" module>
  .container {
    height: 280px;
  }
</style >

<script>
  import BarChart from '../../charts/BarChart';
  export default {
    props: ['data'],
    data: () => ({
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            ticks: {
              min: 0,
              max: 100
            },
            stacked: true
          }]
        }
      }
    }),
    computed: {
      zone_types() {
        return this.$config['zone_types']
      },
      chartData() {
        const {data, zone_types} = this;
        const dataWithTravel = Object.keys(data).reduce((acc, date) => {
          const travel = (100 - Object.values(data[date]).reduce((a, b) => a + b, 0)).toFixed(2);
          return {
            ...acc,
            [date]: {
              ...data[date],
             // travel: parseFloat(travel)
            }
          }
        }, {});

        const dates = Object.keys(dataWithTravel);

        const zones = dates.reduce((acc, date) => {
          return [
            ...acc,
            ...Object.keys(dataWithTravel[date])
          ]
        },[]).filter((value, index, array) => array.indexOf(value) === index);

        const datasets = zones.map(zone => {
          return {
            label: zone,
            backgroundColor: zone_types[zone].color,
            data: dates.map(date => {
              return dataWithTravel[date][zone] || 0
            })
          }
        });

        return {
          labels: dates.map(date => {return 'week ' + (parseInt(date) + 1);}),
          datasets
        };
      },
    },
    components: {
      BarChart
    },
  }
</script>
